module.exports = __webpack_public_path__ + "static/media/lo5d_post_D.a96a1f6f.png";